// * 文件信息
export const fileObject = state => {
  return {
    id: state.routeInfo.id,
    fileId: state.routeInfo.fileId,
    docId: state.routeInfo.docId,
    seqId: state.routeInfo.seqId,
    userId: state.routeInfo.userId,
    from: state.routeInfo.from,
    to: state.routeInfo.to,
    groupId: state.routeInfo.groupId,
    docSize: state.routeInfo.docSize,
    docSource: state.routeInfo.docSource,
    docName: state.routeInfo.docName,
    version: state.routeInfo.version,
    updateTime: state.routeInfo.updateTime,
    windowName: state.routeInfo.windowName,
    skipPermission: state.routeInfo.skipPermission,
    orgId: state.routeInfo.orgId,
    crmId: state.routeInfo.crmId,
    openApiBesaUrl: state.routeInfo.openApiBesaUrl || '',
  }
}

// * 文件类型
export const docType = state => {
  if(!state.routeInfo.docName) return -1
  const arr = state.routeInfo.docName.split('.')
  const type = arr[arr.length - 1]
  return type
}

// * 文件名称
export const docName = state => {
  const fileName = state.routeInfo.docName
  if(!fileName) return ''
  const lastPointIndex = fileName.lastIndexOf('.')
  const name = fileName.slice(0, lastPointIndex)
  return name
}


// * 登录信息
export const loginObject = state => {
  const { userToken, crmId, orgId, userId, token, loginType, projectId } = state.routeInfo
  return {
    userToken,
    crmId,
    orgId,
    userId,
    token,
    loginType,
    projectId
  }
}

// * 是否是 PC 过来的
export const isPc = state => {
  return state.isPC
}

// * 日志标识id
export const operationId = state => {
  return state.operationId
}

//用户加入得组织列表
export const orgListByUser = state => {
  return state.orgListByUser
}



// WEBPACK FOOTER //
// ./src/store/getters.js